import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteChildrenProps, useLocation } from 'react-router'
import CheckoutViewModel from './CheckoutViewModel'
import ApplyCouponAsAdminDialog from '../Job/ApplyCouponAsAdminDialog'
import Summary from './Summary'
import Payment from './Payment'
import { useActivation } from 'hooks/mobx-hooks'
import RemoveCouponAsAdminDialog from '../Job/RemoveCouponAsAdminDialog'
import styles from './Checkout.sass'
import CheckoutSuccess from './Success'

/**
 * Props for the component.
 */
export interface Props extends RouteChildrenProps<{ jobId?: string }> {
  vm: CheckoutViewModel
}

export default observer(function Checkout({ vm, match }: Props) {
  useActivation(vm)
  const location = useLocation()
  const qs = new URLSearchParams(location.search)
  const jobIds = getJobIdsFromParams(qs, match)
  useEffect(() => {
    if (jobIds) {
      vm.fetchCheckoutInfo(jobIds)
    }
  }, [])

  if (vm.checkoutCompleted) {
    return <CheckoutSuccess />
  }

  return (
    <div className={styles.root}>
      <Summary vm={vm} />
      <Payment vm={vm} />

      {vm.jobCheckoutVMs.map(
        (jobVM) =>
          jobVM.canAddCoupons && (
            <>
              {jobVM.applyCouponAsAdminVM !== null && (
                <ApplyCouponAsAdminDialog vm={jobVM.applyCouponAsAdminVM} />
              )}
              {jobVM.removeCouponAsAdminVM !== null &&
                Boolean(jobVM.job.couponCodes) && (
                  <RemoveCouponAsAdminDialog vm={jobVM.removeCouponAsAdminVM} />
                )}
            </>
          ),
      )}
    </div>
  )
})

function getJobIdsFromParams(qs: URLSearchParams, match: any): string[] {
  if (match?.params?.jobId) {
    return [match.params.jobId]
  }

  const jobIds = qs.get('job_ids')
  return jobIds ? jobIds.split(',').filter((i) => i) : []
}
